var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.contents)?_c('div',{directives:[{name:"image-modal",rawName:"v-image-modal",value:(_vm.enableImageModal),expression:"enableImageModal"}],ref:"mdRoot",staticClass:"mark-down-sb",class:{ 'image-modal-enabled': _vm.enableImageModal },domProps:{"innerHTML":_vm._s(_vm.sanitizedMarkdown)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }